import { createStore } from 'vuex'
import auth from './modules/auth'
import users from './modules/users'
import transactions from './modules/transactions'
import tellers from './modules/tellers'
import students from './modules/students'
import dashboard from './modules/dashboard'
import kiosk from './modules/kiosk'
import tellerDashboard from './modules/tellerDashboard'
import adminReports from './modules/adminReports'

export default createStore({
  // Root state
  state: {
    appName: 'HCET Queue Management System',
    appVersion: '1.0.0',
    apiBaseUrl: process.env.VUE_APP_API_BASE_URL ||
      ((window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1')
        ? 'http://localhost:8000/api'
        : 'https://api.illyradev.com'),
    sidebarCollapsed: false
  },

  // Root getters
  getters: {
    appName: state => state.appName,
    appVersion: state => state.appVersion,
    apiBaseUrl: state => state.apiBaseUrl,
    sidebarCollapsed: state => state.sidebarCollapsed
  },

  // Root mutations
  mutations: {
    SET_SIDEBAR_COLLAPSED(state, value) {
      state.sidebarCollapsed = value
    }
  },

  // Root actions
  actions: {
    toggleSidebar({ commit, state }) {
      commit('SET_SIDEBAR_COLLAPSED', !state.sidebarCollapsed)
      // Save to localStorage for persistence
      localStorage.setItem('sidebar_collapsed', !state.sidebarCollapsed)
    },

    initApp({ commit }) {
      // Load sidebar state from localStorage
      const sidebarCollapsed = localStorage.getItem('sidebar_collapsed') === 'true'
      commit('SET_SIDEBAR_COLLAPSED', sidebarCollapsed)
    }
  },

  // Modules
  modules: {
    auth,
    users,
    transactions,
    tellers,
    students,
    dashboard,
    kiosk,
    tellerDashboard,
    adminReports
  }
}) 